import initialState from "./InitialStates";
import Actions from "../actions/Actions";
import update from "immutability-helper";
import {message} from "antd";

message.config({
    top: 70,
    maxCount: 2,
});

const insuranceReducer = (state = initialState.insurance, action) => {

    switch (action.type) {
    case Actions.INSURANCE_MORE_REQUEST:
        return update(state, {
            isLoading: {$set: true},
            name: {$set: ""},
            phone: {$set: ""},
            nic: {$set: ""},
            email: {$set: ""},
            policyNo: {$set: ""}
        });

    case Actions.INSURANCE_MORE_SUCCESS:
        return update(state,
            {
                isLoading: {$set: false},
                name: {$set: action.payload.results[0].firstName},
                phone: {$set: action.payload.results[0].phoneNumber},
                nic: {$set: action.payload.results[0].nic},
                email: {$set: action.payload.results[0].email},
                policyNo: {$set: action.payload.results[0].policyNumber},
                nicFrontImg: {$set: action.payload.images[0]},
                nicBackImg: {$set: action.payload.images[1]},
                policy_img: {$set: action.payload.images[2]}
            });

    case Actions.INSURANCE_MORE_FAIL:
        return update(state, {isLoading: {$set: false}});

    case Actions.INSURANCE_EXPORT_REQUEST:
        return update(state, {
            isExporting: {$set: true},
            exportSuccess: {$set: false},
            exportFail: {$set: false},
        });

    case Actions.INSURANCE_EXPORT_SUCCESS:
        return update(state, {
            isExporting: {$set: false},
            exportSuccess: {$set: true},
        });

    case Actions.INSURANCE_EXPORT_FAIL:
        return update(state, {
            isExporting: {$set: false},
            exportSuccess: {$set: false},
            exportFail: {$set: true},
        });

    default:
        return state;
    }
};

export default insuranceReducer;